var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.681 473.681",
    style: {
      enableBackground: "new 0 0 473.681 473.681"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D62427"
    },
    cx: 236.85,
    cy: 236.85,
    r: 236.83
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC3027"
    },
    d: "M0.001,236.842C0.001,106.028,106.037,0,236.836,0c130.807,0,130.807,473.681,0,473.681 C106.04,473.677,0.001,367.641,0.001,236.842z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F8D12E"
    },
    points: "136.618,65.207 147.669,99.237 183.452,99.237 154.505,120.257 165.563,154.287  136.618,133.26 107.675,154.287 118.732,120.257 89.788,99.237 125.561,99.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F8D12E"
    },
    points: "220.081,45.851 216.596,57.788 226.866,64.792 214.443,65.155 210.965,77.099  206.766,65.39 194.335,65.768 204.174,58.158 199.975,46.457 210.251,53.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F8D12E"
    },
    points: "220.081,152.754 216.596,164.687 226.866,171.691 214.443,172.058 210.965,183.998  206.766,172.29 194.335,172.671 204.174,165.061 199.975,153.36 210.251,160.357  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F8D12E"
    },
    points: "250.383,78.434 246.898,90.371 257.171,97.375 244.745,97.745 241.262,109.682  237.064,97.973 224.637,98.351 234.469,90.741 230.275,79.04 240.553,86.044  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F8D12E"
    },
    points: "250.383,122.015 246.898,133.952 257.171,140.956 244.745,141.322 241.262,153.263  237.064,141.558 224.637,141.936 234.469,134.326 230.275,122.624 240.553,129.621  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.4c3d9bc1.svg";
export { ForwardRef as ReactComponent };